import { Component, ViewEncapsulation, Output, EventEmitter, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { OvsComponent, Core, ApplicationConfiguration } from '../shared/core/ovs.core';
import { Geocoder, GeocoderResult } from '../shared/geo/ovs.geocoding';
import { ResortApplicationBase } from '../services/resort-application.service';
import { SearchState } from '../models/browser.model';
import { ResortAvailability, ResortApplicationConfiguration } from '../models/presentation.model';
import * as moment from 'moment';

@Component({ 
    selector: 'search-calendar',
    templateUrl: './search-calendar.component.html',
    styleUrls: ['./search-calendar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SearchCalendarComponent extends OvsComponent
{
    @Input() 
    public selection: Date = new Date();
    @Output("selectedDateChanged") 
    public selectionChange: EventEmitter<Date> = new EventEmitter<Date>();
    public groups: SearchCalendarItemGroup[];
    public dropdownClicked:boolean;
    @Input() public roundSearchBar:boolean;

    public toggleCalendar() {
        this.dropdownClicked = !this.dropdownClicked;
    }

    @ViewChild('calendarPanel') private calendarPanel : ElementRef;
    @HostListener ('document:click', ['$event'])
    public onClose(){
        // Close calendar panel on document click
        if (!this.calendarPanel.nativeElement.contains(event.target)){
            this.dropdownClicked = false;
        }
    }

    constructor()
    {
        super();
    }

    protected initialize(): void
    {   
       if (this.selection === undefined || this.selection === null || !this.isValidDate(this.selection)) {
            this.selection = new Date();
         } else {
            if (this.selection < new Date()) {
                this.selection = new Date();
            } 
        }
        this.selectionChange.emit(this.selection);
    }

    protected isValidDate(d) {
        return d instanceof Date && !isNaN(d.getTime());
    }


    protected configurationChanged(): void
    {
        let groups: SearchCalendarItemGroup[] = [];

        let config: ResortApplicationConfiguration = <ResortApplicationConfiguration>this.configuration;

        if (config)
        {
            // Sort the incoming items by date, just in case.
            let items: ResortAvailability[] = config.Availability;
            let years: number[] = items.select(i => i.Year).distinct().toArray();

            years.forEach(year =>
            {
                let group: SearchCalendarItemGroup = new SearchCalendarItemGroup(); 
                group.Year = year;
                group.Items = [];
                for (let month: number = 1; month <= 12; month++)
                {
                    let item: ResortAvailability = items.firstOrDefault(i => i.Year == year && i.Month == month);
                    if (!item)
                    {
                        item = new ResortAvailability();
                        item.Month = month;
                        item.Year = year;
                    }
                    else
                    {
                        item.isAvailable = true;
                    }
                    item.date = new Date(item.Year, item.Month - 1, 1);
                    group.Items.add(item);
                }
                groups.add(group);
            }); 
        }

        this.groups = groups;
    }

    public select(selection: ResortAvailability): void
    {
        if (!selection.isAvailable)
            return;

        this.groups.forEach(g => g.Items.forEach(i => i.isSelected = false));
        selection.isSelected = true;
        this.selection = selection.date;
        this.selectionChange.emit(this.selection);
    }
}

class SearchCalendarItemGroup
{
    public Year: number;
    public Items: ResortAvailability[];
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-listing/search-calendar.component.ts